module.exports = {
  ScenarioData: () => {
    return [
      {
        "id": "casaresidencial",
        "name" : "Casa Residencial",
        "modelfile": "Scene_03.glb",
        "is360" : false,
        "target" : {"x": 253.5, "y": 3.2, "z": 127.2},
        "startingcoords" : {"alpha": -45, "beta": 70, "radius": 35},
        "camerafov" : 20,
        "limitradius": {"lower": 10, "upper": 60},//60
        "limitbeta": {"lower": 0, "upper": 75},
        "productsRoof": ["sintraslapo","master1000","arquitectonica"],//,"master1000","arquitectonica"
        "productsFacade": [],
        "icon": require('../assets/scenarios/icon/scenario_03.webp'),
        "background": require('../assets/scenarios/scenario_03.webp'),
        "interactable" : true,
        "active" : true,
      },
      {
        "id": "casavacacional",
        "name" : "Casa Vacacional",
        "modelfile": "Scene_04.glb",
        "is360" : false,
        "target" : {"x": 240.5, "y": 3.2, "z": 112.91},
        "startingcoords" : {"alpha": 15, "beta": 75, "radius": 50},
        "camerafov" : 20,
        "limitradius": {"lower": 20, "upper": 90},//90
        "limitbeta": {"lower": 0, "upper": 75},
        "productsRoof": ["sintraslapo","master1000","arquitectonica"],//,"master1000","arquitectonica"
        "productsFacade": [],
        "icon": require('../assets/scenarios/icon/scenario_04.webp'),
        "background": require('../assets/scenarios/scenario_04.webp'),
        "interactable" : true,
        "active" : true,
      },
      {
        "id": "bodega1",
        "name" : "Bodega 1",
        "modelfile": "Scene_01.glb",
        "is360" : false,
        "target" : {"x": 245, "y": 5.0, "z": 143},
        "startingcoords" : {"alpha": -60, "beta": 70, "radius": 90},
        "camerafov" : 20,
        "limitradius": {"lower": 20, "upper": 100},//100
        "limitbeta": {"lower": 0, "upper": 75},        
        "productsRoof": ["canaleta", "sintraslapo"],
        "productsFacade": ["arquitectonica", "master1000", "sintraslapo"],
        "icon": require('../assets/scenarios/icon/scenario_01.webp'),
        "background": require('../assets/scenarios/scenario_01.webp'),
        "interactable" : true,
        "active" : true,
      },
      {
        "id": "bodega2",
        "name" : "Bodega 2",
        "modelfile": "Scene_02.glb",
        "is360" : false,
        "target" : {"x": 191.5, "y": 5.5, "z": 88.45},
        "startingcoords" : {"alpha": 45, "beta": 65, "radius": 180},
        "camerafov" : 20,
        "limitradius": {"lower": 45, "upper": 180},//180
        "limitbeta": {"lower": 0, "upper": 75},
        "productsRoof": ["canaleta", "sintraslapo"],
        "productsFacade": ["arquitectonica", "master1000", "sintraslapo"],
        "icon": require('../assets/scenarios/icon/scenario_02.webp'),
        "background": require('../assets/scenarios/scenario_02.webp'),
        "interactable" : true,
        "active" : true,
      },
      {
        "id": "coworkingoficinas",
        "name" : "Coworking y Oficinas",
        "modelfile": "",
        "is360" : true,
        "hotspots360": {
          "space01" : {
            "rotation" : 180,
            "hotspots" : [
              {
                "name": "space03",
                "position": {
                  x: 10.0,
                  y: 0.0,
                  z: 0.0
                }
              }
            ]
          },
          "space03" : {
            "rotation" : 150,
            "hotspots" : [
              {
                "name": "space01",
                "position": {
                  x: 10.0,
                  y: 0.0,
                  z: 0.0
                }
              }
              ,
              {
                "name": "space02",
                "position": {
                  x: 4.0,
                  y: 0.0,
                  z: -10.0
                }
              },
            ]
          },
          "space02" : {
            "rotation" : 115,
            "hotspots" : [
              {
                "name": "space01",
                "position": {
                  x: -7.0,
                  y: 0.0,
                  z: -10.0
                }
              }
              ,
              {
                "name": "space03",
                "position": {
                  x: 10.0,
                  y: 0.0,
                  z: -10.0
                }
              }
            ]
          }
        },
        "target" : {"x": 0, "y": 0, "z": 0},
        "startingcoords" : {"alpha": 0, "beta": 90, "radius": 0.1},
        "camerafov" : 60,
        "limitradius": {"lower": 0.1, "upper": 0.1},
        "limitbeta": {"lower": 0, "upper": 180},
        "productsRoof": ["metaldeck"],
        "productsFacade": [],
        "icon": require('../assets/scenarios/icon/scenario_05.webp'),
        "background": require('../assets/scenarios/scenario_05.webp'),
        "interactable" : true,
        "active" : true,
      },
    ]
  }
}